import { SectionVM } from 'civil-status/view-models/step-form';
import { ModelEventoDTO } from 'shell/models/act-category-list';

export const transformerGeneralData = (values?: ModelEventoDTO): SectionVM | undefined => {
  if (!values) {
    return;
  }

  return {
    typeAgreement: values.separazione?.tipoAccordo || '',
    isLawyerHusband: values.separazione?.presenzaAvvocatoConiuge1 || false,
    isLawyerWife: values.separazione?.presenzaAvvocatoConiuge2 || false,
  };
};
